// TODO QS-10687: Replace with the official third-party logo when available.
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUtoolityGitbookIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-utoolity-gitbook-dev" */ './utils').then(
			(m) => m.ForgeUtoolityGitbookIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/icon' },
);

const LazyForgeUtoolityGitbookSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-utoolity-gitbook-dev-search-result" */ './utils').then(
			(m) => m.ForgeUtoolityGitbookSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUtoolityGitbookIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUtoolityGitbookIconComponent />
	</Suspense>
);

export const ForgeUtoolityGitbookSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUtoolityGitbookSearchResultIconComponent />
	</Suspense>
);
